<h2 class="h2-component">
  {{ 'common.reviewsTitle' | cxTranslate }}
</h2>
<app-custom-trustedshops-widget [widgetType]="widgetType"></app-custom-trustedshops-widget>
